<template>
  <v-overlay z-index="1000" :value="visible">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Loader.vue